import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import 'rxjs/add/operator/finally';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import { ToastService } from 'libs/mdbootstrap/typescripts/pro';
import { fadeIn } from 'libs/mdbootstrap/typescripts/pro/animations/animations.component';
import { AuthenticationService } from 'app/core/authentication/authentication.service';
import * as Models from 'app/core/models';
import { UserService } from 'app/core/user/user.service';
import { LookupService } from 'app/core/lookup/lookup.service';
import { ModalService } from 'app/modal/modal.service';
import { ProcessService } from 'app/core/process/process.service';
import { ProcessAuthorizationType } from '../../core/models/process.model';


@Component({
  selector: 'app-publish-process-modal',
  templateUrl: './publishProcessModal.component.html',
  styleUrls: ['./publishProcessModal.component.scss']
})

export class PublishProcessModalComponent implements OnInit, Models.ModalComponent {

  @ViewChild('modalPublishProcess') public contentModal: any;
  isLoading = false;
  showForm = false;
  showError = false;
  error: any = null;
  isSaving = false;
  medias: Array<Models.Media> = [];
  tags: Array<Models.Tag> = [];
  processId: number;
  processVersionId: string;
  selectedTags: Array<any> = [];
  isPremium = false;
  allowAssistance: boolean = fadeIn;
  coverMediaId: string = null;
  coverSmallUrl: string = null;
  processAuthorization: Array<Models.ProcessAuthorization> = [];
  authorizationType: number;
  setAudience = false;
  audienceList: Array<any> = [];
  authorizationTypeError = false;
  audienceError = false;
  audienceInputError = false;
  audienceInputDirty = false;
  errorText: String;
  usageType: number;

  constructor(private authenticationService: AuthenticationService,
    private userService: UserService,
    private router: Router,
    private lookupService: LookupService,
    private modalService: ModalService,
    private processService: ProcessService,
    private toastrService: ToastService) {
  }

  ngOnInit() {
    this.isLoading = false;
    this.showForm = false;
    this.showError = false;
    this.error = null;
    this.errorText = null;
    this.isSaving = false;
    this.selectedTags = [];
    this.audienceInputDirty = false;
    this.audienceError = false;
    this.audienceInputError = false;

  }

  open() {
    this.contentModal.show();
  }

  close() {
    this.contentModal.hide();
  }

  cancel(): void {
    const resultData: Models.ModalResult = { modalType: Models.ModalType.PROCESS_PUBLISH, result: false };
    this.modalService.returnEvent(resultData);
  }

  closeModal() {
    this.close();
  }

  openModal(data: any[]): void {
    this.processId = data[0];
    this.processVersionId = data[1];
    this.selectedTags = [];
    const selectedTags: Models.Tag[] = data[2];
    selectedTags.forEach(x => {
      this.selectedTags.push({
        tagId: x.tagId,
        text: x.text,
        value: x.tagId,
        display: x.text
      });
    });
    this.isPremium = data[3];
    this.allowAssistance = data[4];
    this.medias = <Models.Media[]>data[5];
    this.coverMediaId = data[6];
    this.coverSmallUrl = data[7];
    this.processAuthorization = data[8];
    this.usageType = data[9];

    this.isLoading = true;
    this.showError = false;
    this.showForm = false;
    this.error = null;
    this.isSaving = false;
    this.audienceInputError = false;
    this.authorizationType = null;

    this.open();

    this.lookupService.getTags()
      .finally(() => {
        if (!this.error) {

        }
        this.isLoading = false;
      })
      .subscribe(tags => {
        this.tags = [];
        tags.forEach(x => {
          const tag: Models.Tag = { tagId: x.tagId, text: x.text };
          this.tags.push(tag);
        });

        this.error = null;
        this.showError = false;
        this.showForm = true;
        this.initAudienceComponent()
      }
        , error => {
          this.error = error;
          this.showError = true;
          this.showForm = false;
        });
  }

  save(): void {
    if (!this.validateAudience()) {
      return;
    }
    this.isSaving = true;
    this.saveTgs();
  }

  saveTgs(): void {
    const tempTags: any[] = [];
    this.selectedTags.forEach(x => {
      const tempTag = Object.assign({}, x);
      if (!Number.isInteger(tempTag.tagId)) {
        tempTag.tagId = 0;
        tempTag.text = tempTag.display;
      }
      tempTags.push(tempTag);
    });
    const tagsData: Models.SaveProcessTagsModel = { processVersionId: this.processVersionId, tags: tempTags };
    this.processService.saveProcessTags(tagsData)
      .finally(() => {
        if (this.error) {
          this.isSaving = false;
        }
      })
      .subscribe(result => {
        this.publishProcess();

      }
        , error => {
          // @TODO: translate
          this.error = error;
          const options = { enableHtml: true };
          this.toastrService.error(this.errorMessage + '<br /> Please try again.', 'There was an error:', options);
        });
  }

  publishProcess(): void {
    const data: Models.ProcessPublishModel = {
      processVersionId: this.processVersionId,
      isPremium: this.isPremium,
      allowAssistance: this.allowAssistance,
      coverMediaId: this.coverMediaId,
      processAuthorization: this.processAuthorization,
      usageType: this.usageType
    };
    this.processService.publish(data)
      .finally(() => {
        this.isSaving = false;
      })
      .subscribe(() => {
        const resultData: Models.ModalResult = { modalType: Models.ModalType.PROCESS_PUBLISH, result: true };
        this.modalService.returnEvent(resultData);
      }
        , error => {
          // @TODO: translate
          this.error = error;
          const options = { enableHtml: true };
          this.toastrService.error(this.errorMessage + '<br /> Please try again.', 'There was an error:', options);
        });
  }

  toggleIsPremium(): void {
    this.isPremium = !this.isPremium;
  }

  toggleAllowAssistance(): void {
    this.allowAssistance = !this.allowAssistance;
  }

  addMedia(): void {
    const data: Models.ModalContext = {
      modalType: Models.ModalType.MEDIA_UPLOAD,
      modalAction: Models.ModalAction.OPEN,
      parameters: [this.processId, this.medias, Models.MediaModalModes.IMAGE],
      leaveOthers: true
    };
    this.modalService.command(data);

    const subscription = this.modalService.returnEvent$.subscribe((resultData: Models.ModalResult) => {
      if (resultData.modalType === Models.ModalType.MEDIA_UPLOAD) {
        const media: Models.Media = <Models.Media>resultData.result;
        if (media) {
          this.coverMediaId = media.mediaId;
          this.coverSmallUrl = media.smallUrl;
        }
        data.modalAction = Models.ModalAction.CLOSE;
        this.modalService.command(data);
        subscription.unsubscribe();
      }
    });
  }

  get errorMessage(): string {
    if (this.error) {
      const errorBody = this.error._body ? JSON.parse(this.error._body) : null;
      if (errorBody && errorBody.error) {
        return errorBody.error;
      }
    }
    // @TODO: translate
    return 'There was a problem.';
  }

  toggleSetAudience() {
    this.setAudience = !this.setAudience;
    this.audienceInputDirty = false;
    if (!this.setAudience) {
      this.processAuthorization = [];
      this.authorizationType = null;
    }
  }

  toggleIsPrivate() {
    this.authorizationTypeError = false;
    this.audienceInputError = false;
    if (this.authorizationType === ProcessAuthorizationType.IsPrivate) {
      this.processAuthorization = [];
      this.audienceList = [];
      this.addAuthorization(null, ProcessAuthorizationType.IsPrivate);
    }
  }

  toggleAudienceList() {
    this.audienceList = [];
  }

  addAuthorization(item: any, authorizationType: number) {
    this.audienceInputDirty = false;
    const auth = new Models.ProcessAuthorization();
    auth.processId = this.processId;
    auth.audience = item ? item.value : null;
    auth.authorizationType = authorizationType;
    this.processAuthorization.push(auth);
    this.audienceError = false;

    if (item && !this.validateAudienceInput(item.value, authorizationType)) {
      this.onRemoveAudience(item);
    }
  }

  onRemoveAudience(item: any) {
    this.audienceInputDirty = false;
    const removePAIndex = this.processAuthorization.map(pa => {
      return pa.audience;
    }).indexOf(item.value);

    if (removePAIndex > -1) {
      this.processAuthorization.splice(removePAIndex, 1);
    }

    const removeAudienceIndex = this.audienceList.map(pa => {
      return pa.value;
    }).indexOf(item.value);

    if (removeAudienceIndex > -1) {
      this.audienceList.splice(removePAIndex, 1);
    }
  }

  onAudienceInputChange(event: Event) {
    if (this.authorizationType > 1 && event) {
      this.audienceInputDirty = true;
      this.audienceInputError = false;
    }
    else {
      this.audienceInputDirty = false;
    }
  }

  validateAudience(): boolean {
    const valid = true;
    if (this.setAudience && (!this.authorizationType || this.authorizationType === null)) {
      this.authorizationTypeError = true;
      return false;
    }
    if (this.setAudience && this.authorizationType !== Models.ProcessAuthorizationType.IsPrivate && !this.audienceList.length) {
      this.audienceError = true;
      return false;
    }

    return valid;
  }

  validateAudienceInput(audience: string, authorizationType: number) {
    this.audienceInputError = false;
    let valid = true;
    if (authorizationType === Models.ProcessAuthorizationType.Emails) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      valid = re.test(String(audience).toLowerCase());
    } else if (authorizationType === Models.ProcessAuthorizationType.Domains) {
      const re = /^((?:(?:(?:\w[\.\-\+]?)*)\w)+)((?:(?:(?:\w[\.\-\+]?){0,62})\w)+)\.(\w{2,6})$/;
      valid = re.test(audience);
    }
    // this.audienceInputError = !valid;
    if (!valid) {
      this.showAudienceInputError();
    }

    return valid;
  }

  initAudienceComponent() {
    this.audienceList = [];
    this.setAudience = this.processAuthorization.length > 0;
    if (this.setAudience) {
      this.authorizationType = +this.processAuthorization[0].authorizationType;
      switch (this.authorizationType) {
        case Models.ProcessAuthorizationType.Emails:
        case Models.ProcessAuthorizationType.Domains:
          this.buildAudienceList();
          break;
      }
    }
  }

  buildAudienceList() {
    this.processAuthorization.forEach(item => {
      this.audienceList.push(item.audience);
    })
  }

  showAudienceInputError(): void {
    var self = this;
    self.audienceInputError = true;
    setTimeout(function () {
      self.audienceInputError = false;
    }, 5000);
  }

  get isAudienceTypeValid(): Boolean {
    return !this.setAudience || (this.setAudience && this.authorizationType != null);
  }

  get isAudienceListValid(): Boolean {
    return this.authorizationType == null || this.authorizationType == 1 || (this.authorizationType != null && this.audienceList != null && this.audienceList.length > 0);
  }

  get isAudienceInputValid(): Boolean {
    return !this.audienceInputError;
  }
}



// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/app/shared/publishProcessModal/publishProcessModal.component.ts